/**
 * ObjectCodeField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import TextField from '@material-ui/core/TextField';


/**
 * ObjectCodeField is an editing component for source code fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectCodeField extends React.Component {

    handleChange(event) {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(this.props.fieldDef.id, value);
    };

    render() {

        const { classes, fieldDef } = this.props;

        const inputProps = {
            style: {
                fontFamily: "monospace,monospace"
            },
            readOnly: this.props.readOnly
        };

        return (
            <TextField
                id={fieldDef.id}
                label={fieldDef.name}
                disabled={this.props.readOnly} // TODO: make text selectable for copy/paste
                value={this.props.value}
                className={classes.codeField}
                InputProps={inputProps}
                onChange={event => this.handleChange(event)}
                margin="normal"
                multiline={true}
                fullWidth={true}
                type="text"
                helperText={fieldDef.note}
                variant="outlined"
                rows={15}
                rowsMax={20}
            />
        );
    }
}

ObjectCodeField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    codeField: {
        marginTop: 16
    }
};

export default withStyles(styles)(ObjectCodeField);